export { Toolbar, type ToolbarHandle, type ToolbarOptions } from './toolbar.js'
export {
  DEFAULT_LAYOUT,
  LAYOUT_WITH_COLOUR,
  allToolbarItems,
  getToolbarItem,
  onRegistryChange,
  registerToolbarItem,
  type ToolbarContext,
  type ToolbarControl,
  type ToolbarItemSpec,
  type ToolbarSelectOption,
} from './registry.js'
export { SOURCE_TOGGLE_EVENT, FULLSCREEN_TOGGLE_EVENT, VISUAL_AIDS_TOGGLE_EVENT, registerDefaultItems } from './items.js'
export {
  t,
  fill,
  setUiLocale,
  uiLocale,
  registerTranslations,
  onLocaleChange,
  withLocale,
} from './i18n.js'
export {
  MenuBar,
  PopupMenu,
  DEFAULT_MENUBAR,
  selectMenus,
  LINK_CONTEXT_ITEMS,
  IMAGE_CONTEXT_ITEMS,
  TABLE_CONTEXT_ITEMS,
  type MenuSpec,
  type MenuEntry,
  // `MenuEntry` is `MenuItemRef | '|'`, so building a menu entry by hand meant
  // naming a type that was not exported.
  type MenuItemRef,
} from './menu.js'
export { announce, disposeLiveRegion, liveRegion } from './live.js'
export { promptHelp } from './help.js'
export {
  FloatingToolbars,
  DEFAULT_SELECTION_LAYOUT,
  DEFAULT_INSERT_LAYOUT,
} from './floating.js'
export { loadContentCss, contentCssUrls, scopeContentCss } from './content-css.js'
export { CSS } from './css.js'
export { ensureStyles, markStylesExternal, registerStyles } from './styles.js'
export {
  DIRECTIONAL,
  ensureSprite,
  iconElement,
  iconNames,
  registerIcons,
  type IconName,
} from './icons.js'
export {
  promptFields,
  promptForImage,
  promptForLink,
  promptForMedia,
  type FieldOption,
  type FieldSpec,
  type ImagePromptOptions,
  type ImageResult,
  type LinkResult,
  type MediaPromptOptions,
  type MediaResult,
  type MediaSourceResult,
  type PromptFormOptions,
} from './dialog.js'
export {
  filePickerFor,
  listedImageClasses,
  listedImages,
  listedLinks,
  registerFilePicker,
  registerImageClasses,
  registerImageList,
  registerLinkList,
  type FilePicker,
  type FilePickerKind,
  type ListedResource,
  type PickedResource,
} from './pickers.js'
export {
  IMAGE_ACCEPT,
  canUploadImages,
  imageFilesFrom,
  imageUploaderFor,
  isHeicImage,
  isUploadableImage,
  isUploadableImageType,
  registerImageUploader,
  runUploader,
  type ImageUploadResult,
  type ImageUploader,
} from './upload.js'
export {
  BUILT_IN_SKINS,
  applyColourScheme,
  applySkin,
  availableSkins,
  ensureSkins,
  registerSkin,
  type ColourScheme,
  type Skin,
} from './skins.js'
export { embeddedStylesPlugin } from './embedded-styles.js'

export { findEditorHost, canvasPoint } from './editor-host.js'
export { mirrorRegisteredStyles } from './styles.js'
